// @ts-nocheck
import type { ItemDefinition } from '../../../../../shims/appStub';

/** Item fields that must not be mutated via template itemField writes. */
export const BLOCKED_ITEM_FIELD_WRITES = new Set<string>([
  'id',
  'parentId',
  'originalId',
  'collectionShareId',
  'collectionShareParentId',
  'sharedCollectionId',
  'createdAt',
  'templateId',
  'templateElementId',
  'processingId',
]);

export function normalizeMutationItemId(id: number | string): string {
  return String(id);
}

export function isWritableItemField(field: string): boolean {
  return !BLOCKED_ITEM_FIELD_WRITES.has(field);
}

/** Legacy template bindings (e.g. default.v2.json) → ItemDefinition keys. */
const ITEM_FIELD_READ_ALIASES: Record<string, keyof ItemDefinition> = {
  name: 'title',
  quantity: 'amount',
};

export function resolveItemFieldKey(field: string): keyof ItemDefinition | string {
  return ITEM_FIELD_READ_ALIASES[field] ?? field;
}

export function hasItemField(item: ItemDefinition, field: string): boolean {
  const key = resolveItemFieldKey(field);
  return Object.prototype.hasOwnProperty.call(item, key);
}

export function readItemFieldValue(item: ItemDefinition, field: string): unknown {
  const key = resolveItemFieldKey(field);
  if (!Object.prototype.hasOwnProperty.call(item, key)) {
    return undefined;
  }
  return (item as Record<string, unknown>)[key as string];
}
